__turbopack_context__.v({
  "error": "index-module__3WMYPq__error" + " " + __turbopack_context__.i(367887)["error"],
  "input": "index-module__3WMYPq__input" + " " + __turbopack_context__.i(367887)["input"],
  "label": "index-module__3WMYPq__label" + " " + __turbopack_context__.i(367887)["label"],
  "root": "index-module__3WMYPq__root" + " " + __turbopack_context__.i(367887)["root"],
  "section": "index-module__3WMYPq__section" + " " + __turbopack_context__.i(367887)["section"],
});
